var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8133,
    cy: 19.328,
    rx: 18.8133,
    ry: 18.8133,
    fill: "#7CB6E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.923 29.3245V20.3284H23.6523L24.0981 16.3302H20.923V14.3828C20.923 13.3532 20.9492 12.3319 22.3869 12.3319H23.8431V9.47333C23.8431 9.43035 22.5923 9.33325 21.3269 9.33325C18.6842 9.33325 17.0295 10.9897 17.0295 14.0314V16.3302H14.1094V20.3284H17.0295V29.3245H20.923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.24d523e3de5a096598a2daa72d31c056.svg";
export { ForwardRef as ReactComponent };